

$(function(){
  $('.headerFW ul.level_1>li.first>*').html('<i class="fas fa-home"></i>');
  loadBackgrounds();

  $('.rsce_listPeople').each(function(){
    var rsce = $(this);
    rsce.find('.rsce_listPeople__list button[data-item]').on('click',function(){
      $('.mod_breadcrumb').addClass('hidden');
      rsce.find('.rsce_listPeople__headline,.rsce_listPeople__list,.rsce_listPeople__reader__item').removeClass('active');
      rsce.find('.rsce_listPeople__reader,.rsce_listPeople__reader__item[data-item="'+$(this).data('item')+'"]').addClass('active');
    });
    rsce.find('button.backToList').on('click',function(){
      $('.mod_breadcrumb').removeClass('hidden');
      rsce.find('.rsce_listPeople__headline,.rsce_listPeople__list').addClass('active');
      rsce.find('.rsce_listPeople__reader,.rsce_listPeople__reader__item').removeClass('active');
    })
  });

  $('.ce_hyperlink').each(function(){
    var classes = $(this).attr("class");
    $(this).find('a').addClass(classes).removeClass('ce_hyperlink hyperlink_txt block').unwrap();
  });

  // if (navigator.userAgent.match(/(android|iphone|ipad|blackberry|symbian|symbianos|symbos|netfront|model-orange|javaplatform|iemobile|windows phone|samsung|htc|opera mobile|opera mobi|opera mini|presto|huawei|blazer|bolt|doris|fennec|gobrowser|iris|maemo browser|mib|cldc|minimo|semc-browser|skyfire|teashark|teleca|uzard|uzardweb|meego|nokia|bb10|playbook)/gi)) {
  //   $('body').addClass('mobile');
  // }

  $('body:not(.mobile) #header a[href*="tel"]').on('click',function(e){
    e.preventDefault();
    window.location.href = $(this).data('alt');
  });
  $('#header a[href*="tel"]').removeClass('no-events');


  // testimonial overide
  setTimeout(function(){
    $.each(app.components_active.sliderFW,function(){
      if(this.$el.hasClass('preset--testimonial')){
        var slider = this;
        slider.autoTrigger = function() {
          var slider = this;
          slider.timerAuto = setTimeout(function(){
              slider.goToNext()
          },15000);
        };
        if(slider.auto){
          slider.$el.bind('mouseenter',function(){
            clearTimeout(slider.timerAuto);
          });
          slider.$el.bind('mouseleave',function(){
            slider.autoTrigger();
          });
        }
      }
    });
},1)
});

var loadBackgrounds = function () {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (resolve, reject) {
        var elems = $('*[data-bg]');
        $.each(elems, function (index, elem) {
            var src = $(elem).attr('data-bg');
            if (src != "") {
                var $img = $('<img>').attr('src', src).on('load', function () {
                    $(elem).css('background-image', 'url("' + src + '")').addClass('has-img');
                }).on('error', function (ev) {
                    // $(elem).css('background-image', 'url("files/app/img/img-not-found.png")').addClass('has-img not-found');
                });
            }
        });
        if (callback) {
            callback();
        }
        resolve();
    });
};


// WEBPACK FOOTER //
// ./src/themes/mdf/mdf.js